"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import HomeSection from "@/components/home-section";
import Faculty from "@/components/card/faculty";
import SwiperNav from "@/components/swiper-nav";

const faculties = [
  {
    name: "Shashank Tyagi",
    speciality: "UPSC Faculty",
    facultyImage: "/studyiq-next/images/teaching-experts/shashank-tyagi.png",
    items: [
      "Total Experience: **10 Years**",
      "Students Taught so far: **10,000+**",
      "**Subjects:** PSIR, Polity, Governance, IR, Interview Preperation",
      "**Exams Given:** UPSC Interview, Ex-Consultant (Govt. of NCT Delhi)",
    ],
  },
  {
    name: "Chandan Sharma",
    speciality: "UPSC Faculty",
    facultyImage: "/studyiq-next/images/teaching-experts/chandan-sharma.png",
    items: [
      "Total Experience: **07 Years**",
      "Students Taught so far: **10,000+**",
      "**Subjects:** History, Current Affairs",
      "**Exams Given:** UPSC Mains (2 Times)",
    ],
  },

  {
    name: "Bhuvan Apoorva Jha",
    speciality: "UPSC Faculty",
    facultyImage:
      "/studyiq-next/images/teaching-experts/bhuvan-apoorva-jha.png",
    items: [
      "Total Experience: **05 Years**",
      "Students Taught so far: **22,000+**",
      "**Subjects:** Geography Optional, Environment, Disaster Management, Essay, Interview Prep.",
      "**Exams Given:** UPSC Interviews & Ex - Govt. of India",
    ],
  },
];

function TeachingExperts() {
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  const [swiper, setSwiper] = React.useState();

  React.useEffect(() => {
    if (swiper) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  return (
    <HomeSection
      title="Our Faculties"
      subtitle={
        <>
          <span>Meet our</span>
          <span className="text-primary">Top Teaching Experts</span>
        </>
      }
      className="block space-y-4"
    >
      <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={1}
        spaceBetween={16}
        onSwiper={setSwiper}
        autoplay={{
          delay: 5000,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          480: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          767: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        }}
        data-testid="teaching-experts-slider"
      >
        {faculties.map((faculty) => (
          <SwiperSlide key={faculty.name} data-testid="teaching-expert-slide">
            <Faculty {...faculty} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="hidden md:flex justify-end">
        <SwiperNav swiper={swiper} prevNavRef={prevRef} nextNavRef={nextRef} />
      </div>
    </HomeSection>
  );
}

export default TeachingExperts;
